import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import api from '../utils/api';

export function useReports(studentId, courseId) {
  const [reports, setReports] = useState([]);
  const [grades, setGrades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const prevStudentId = useRef(studentId);
  const prevCourseId = useRef(courseId);

  // Clear reports synchronously before render when student or course changes
  useLayoutEffect(() => {
    if (prevStudentId.current !== studentId || prevCourseId.current !== courseId) {
      setReports([]);
      setGrades([]);
      setError(null);
      // Set loading true if we have valid IDs (will fetch), false otherwise
      setLoading(!!(studentId && courseId));
      prevStudentId.current = studentId;
      prevCourseId.current = courseId;
    }
  }, [studentId, courseId]);

  useEffect(() => {
    if (!studentId || !courseId) {
      return;
    }

    const fetchReports = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/parent/children/${studentId}/courses/${courseId}/reports`
        );
        setReports(response.data.reports || []);
        setGrades(response.data.grades || []);
        setError(null);
      } catch (err) {
        // Don't treat 404 as error - just means no reports
        if (err.response?.status === 404) {
          setReports([]);
          setGrades([]);
          setError(null);
        } else {
          setError(err.response?.data?.message || 'Failed to fetch reports');
          setReports([]);
          setGrades([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [studentId, courseId]);

  return { reports, grades, loading, error };
}
